import React, {Component} from 'react';
import { Carousel, Picker, List } from 'antd-mobile';
import Blank from '../components/Blank';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import TipPlaceholder from '../components/TipPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import Constants from '../utils/Constants';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import { createForm } from 'rc-form';
import imgBanner01 from '../medias/banner01.jpg';
import imgBanner02 from '../medias/banner02.jpg';
import '../styles/GameRank.css';

const history = require("history").createHashHistory()

class GameRank extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: 'loading',
            game: null,
            rankGames: [],
            gameRank: null,
            userProfile: {},
            brandInfo: null
        }
    }

    componentDidMount() {
        this.gameId = CommonUtils.resolveSearchParam(this.props.location, 'gameId')
        this.userId = CommonUtils.resolveSearchParam(this.props.location, 'userId')

        this.loadBranInfo(() => {
            this.checkUserId(() => {
                this.checkGameId()
            })
        })
    }

    loadBranInfo = (callback) => {
        DataFetcher.brandInfo({
        }, {
            success: (resp) => {
                this.setState({
                    brandInfo: resp.data
                }, () => {
                    BrandUtils.refreshPageBrand(this.state.brandInfo)
                    callback&&callback()
                })
            }
        })
    }

    checkUserId = (callback) => {
        if(this.userId) {
            callback&&callback()
            return
        }

        DataFetcher.profile({
        }, { 
            success: (resp) => {
                this.userId = resp.data.userId
                if(this.gameId) {
                    history.replace(`/rank/game?gameId=${this.gameId}&userId=${this.userId}`)
                    this.doUpdateShareInfo()
                } else {
                    history.replace(`/rank/game?userId=${this.userId}`)
                    this.doUpdateShareInfo()
                }
            },
            logicError: () => {
            },
            sysError: () => {
            },
            completed: () => {
                callback&&callback()
            }
        })
    }

    checkGameId = () => {
        DataFetcher.rankGames({
            userId: this.userId
        }, {
            success: (resp) => {
                this.doCheckGameId(resp)
            },
            logicError: () => {
                this.setState({
                    status: 'nodata'
                })
            },
            sysError: () => {
                this.setState({
                    status: 'nodata'
                })
            }
        })
    }

    doCheckGameId = (resp) => {
        if(!resp || !resp.data || !resp.data.length) {
            this.setState({
                status: 'nodata'
            })
            return
        }
        
        if(!this.gameId) {
            let gameId = resp.data[0].id
            this.gameId = gameId
            if(this.userId) {
                history.replace(`/rank/game?gameId=${this.gameId}&userId=${this.userId}`)
                this.doUpdateShareInfo()
            } else {
                history.replace(`/rank/game?gameId=${this.gameId}`)
                this.doUpdateShareInfo()
            }
        }
        
        let game
        for(let item of resp.data) {
            if(item.id === this.gameId) {
                game = item
                break
            }
        }

        if(!game) {
            this.setState({
                status: 'nodata'
            })
            return
        }

        this.setState({
            rankGames: resp.data,
            status: 'success',
            game
        }, () => {
            this.loadGameRank()
        })
    }

    loadGameRank = () => {
        const { game } = this.state
        if(!game) return

        DataFetcher.gameRank({
            gameId: game.id,
            userId: this.userId
        }, {
            success: (resp) => {
                this.setState({
                    gameRank: resp.data
                }, () => {
                    this.doUpdateShareInfo()
                })
            },
            completed: () => {
                this.setState({
                    status: 'success'
                })
            }
        })
    }

    onGamePickerChange = (val) => {
        const { rankGames } = this.state

        this.gameId = val[0]
        if(this.userId) {
            history.replace(`/rank/game?gameId=${this.gameId}&userId=${this.userId}`)
            this.doUpdateShareInfo()
        } else {
            history.replace(`/rank/game?gameId=${this.gameId}`)
            this.doUpdateShareInfo()
        }

        let game
        for(let item of rankGames) {
            if(item.id === this.gameId) {
                game = item
                break
            }
        }

        this.setState({
            game
        }, () => {
            this.loadGameRank()
        })
    }

    doUpdateShareInfo = () => {
        const { gameRank, brandInfo } = this.state
        if(!gameRank || !gameRank.gameName) {
            return
        }

        try {
            let link = window.location.href
            if(!link) return

            let imgUrl = gameRank.gameThumbnail
            if(CommonUtils.isEmpty(imgUrl) && brandInfo && CommonUtils.isNotEmpty(brandInfo.wxmpQrCode)) {
                imgUrl = brandInfo.wxmpQrCode
            }

            let desc
            if(gameRank.userRank && gameRank.userRank.rank) {
                desc = `我在“${gameRank.gameName}”中获得了第${gameRank.userRank.rank}名！`
            } else {
                desc = `一起来玩“${gameRank.gameName}”吧！`
            }

            window.wx.ready(function() {
                window.wx.updateTimelineShareData({ title: desc, link, imgUrl })
                window.wx.updateAppMessageShareData({ title: '玩家排行榜', link, imgUrl, desc })
            })
        } catch(e) {
            console.error(e)
        }
    }

    generateBannerView = () => {
        const { game } = this.state

        return (
            <div className='section-banner'>
                <Carousel autoplay={true} infinite>
                    <img src={game.onlineThumbnail?game.onlineThumbnail:imgBanner01} alt=""/>
                    <img src={game.tutorial?game.tutorial:imgBanner02} alt=""/>
                </Carousel>
            </div>
        )
    }

    generateTitleView() {
        const { rankGames } = this.state
        if(!rankGames) {
            return
        }

        let gameId = this.gameId
        const gamePickerData = rankGames.map(item => ({value: item.id, label: item.name}))
        return (
            <div className='section-title'>
                <div className="title word-ellipsis">
                    <Picker 
                        cols={1}
                        value={[gameId]}
                        onOk={this.onGamePickerChange}
                        data={gamePickerData}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-youxiyouxiji'/>
                            <span> 玩家排行榜</span>
                        </List.Item>
                    </Picker>
                </div>
            </div>
        )
    }

    generateQRCodeView = () => {
        const { brandInfo } = this.state
        if(!brandInfo || CommonUtils.isEmpty(brandInfo.wxmpQrCode)) {
            return
        }

        return (
            <div className='section-qrcode'>
                <div className='qrcode-content'>
                    <img src={brandInfo.wxmpQrCode} alt=""/>
                </div>
                <div className='qrcode-tip'>关注公众号</div>
            </div>
        )
    }

    readableRank = (rank) => {
        if(rank > 9999) {
            try {
                let wNum = parseInt(rank / 10000, 10)
                return wNum + '万+'
            } catch(e) {
            }
        }
        return rank
    }

    generateRankView = () => {
        const { gameRank } = this.state
        if(!gameRank || !gameRank.ranks || !gameRank.ranks.length) {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'暂无人上榜'}/>
        }

        return (
            <div className='section-rank'>
                {gameRank.userRank?(
                <div key={-1} className='rank-item self'>
                    <div className='order'>{this.readableRank(gameRank.userRank.rank)}</div>
                    <div className='avatar'><img src={gameRank.userRank.avatar} alt=""/></div>
                    <div className='description'>
                        <div className='nick-name word-ellipsis'>
                            <span>{gameRank.userRank.nickName}</span> 
                            <span className='level'> ({gameRank.userRank.levelValue}/{gameRank.totalLevel})</span>
                        </div>
                        <div className='level-name word-ellipsis'>{gameRank.userRank.levelName}</div>
                    </div>
                    <div className='metric'>
                        <div className='point word-ellipsis'>{this.readablePoint(gameRank.userRank.userPoint)}</div>
                    </div>
                </div>):null}
                {gameRank.ranks.map((item, index) => {
                    return (
                        <div key={index} className={`rank-item ${item.rank<=3?'top':'normal'}`}>
                            <div className='order'>{item.rank}</div>
                            <div className='avatar'><img src={item.avatar} alt=""/></div>
                            <div className='description'>
                                <div className='nick-name word-ellipsis'>
                                    <span>{item.nickName}</span>
                                    <span className='level'> ({item.levelValue}/{gameRank.totalLevel})</span>
                                </div>
                                <div className='level-name word-ellipsis'>{item.levelName}</div>
                            </div>
                            <div className='metric'>
                                <div className='point word-ellipsis'>{this.readablePoint(item.userPoint)}</div>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    readablePoint = (point) => {
        if(!point || point < 10000000) {
            return point
        }

        return (point / 1000).toFixed(1) + 'k'
    }

    doRenderView() {
        return (
            <div className="page-game-rank">
                {this.generateBannerView()}
                <Blank/>
                {this.generateTitleView()}
                <Blank/>
                {this.generateRankView()}
                <Blank/>
                {this.generateQRCodeView()}
            </div>
        )
    }

    render() {
        const {status} = this.state;

        if(status === 'loading') {
            return <LoadingPlaceholder/>;
        } else if (status === 'nodata') {
            return <TipPlaceholder firstTip={Constants.Strings.APP_NAME} secondTip={'暂无数据'}/>;
        } else {
            return this.doRenderView()
        }
    }
}

export default createForm()(GameRank);


// WEBPACK FOOTER //
// ./src/modules/GameRank.js